<template>
  <section>
    <div class="top">
      <div class="container">
        <div class="fl flex">
          <!-- <i class="iconfont icon-map-h color-primary"></i> -->
          <div id="address" class="iconfont icon-map-h color-primary"></div>
          <span id="applocation">
            <el-cascader
              size="large"
              :options="options"
              placeholder="四川省 成都市"
              v-model="selectedOptions"
              class="iconfont icon-map-h color-primary"
              @change="handleChange"
              :style="'width:'+(addrText.length||7)*15+'px'"
            ></el-cascader>
			
          </span>
		  
          <div>
            <!-- <input type="text" placeholder="" name="" id=""> -->
            <span v-if="!userInfo.username" style="margin-left: 20px;">
              请
              <a href="#/login" class="color-primary">登录</a>
            </span>
            <span v-else style="margin-left: 20px;">您好 {{userInfo.username}}</span>
          </div>
          <el-dropdown v-if="userInfo.username">
            <span class="el-dropdown-link">
              <a
                href="javascript:;"
                style="margin-left: 20px;"
                class="top"
                @click="tousercenter"
              >会员中心</a>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>

            <el-dropdown-menu slot="dropdown">
             
              <el-dropdown-item icon="el-icon-switch-button">
                <a href="javascript:;" @click="tologin">退出登录</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <a href="#/register" v-if="!userInfo.username" style="margin-left: 20px;">免费注册</a>
        </div>
        <div class="fr top-r">
          <a href="javascripy:;" @click="myorder">我的订单</a>|
          <a href="javascripy:;" class="iconfont icon-star-h" @click="myfav">我的收藏</a>|
          <a :href="indexData.index_kefu" target="_blank">在线客服</a>
           <a href="javascript:;" class="mallcart teletephone">
            <span class="iconfont icon-tel3"></span> {{indexData.index_telephone}}
           
          </a>
        </div>
      </div>
    </div>
    <div class="index" v-if="userpage">
      <div class="header">
        <div class="container">
          <div class="logo">
            <a href="/" target="_blank">
              <img src="/static/images/logo.png" />
            </a>
          </div>

          <div class="search">
            <input type="text" placeholder="搜索商品关键词" v-model="keyword" />
            <button @click="search">
              <i class="iconfont icon-search"></i>
            </button>
            <div class="hotwords">
              <span>热搜：</span>
              <a :href="item.url"
             target="_blank" 
                v-for="(item,index) in indexData.index_keywords"
                :key="index"
              >{{item.remark}}</a>
            </div>
          </div>
         <div class="flex">
            <a href="#/cart" class="mallcart">
            <span class="iconfont icon-cart"></span> 我的购物车
            <span v-if="cartnum" class="cart-count">{{cartnum}}</span>
            <span class="cart-count" v-else>{{indexData.index_cartnum}}</span>
          </a>
          <!-- <a href="javascript:;" class="mallcart teletephone">
            <span class="iconfont icon-tel3"></span> {{indexData.index_telephone}}
           
          </a> -->
         </div>
        </div>
      </div>
      <div class="nav" v-if="!showNav">
        <div class="container">
          <div class="nav-service">
            <div class="tit">
              <span class="iconfont icon-menu"></span>&nbsp;&nbsp;
              全部商品分类
            </div>
            <div class="downmenu hide">
              <div
                class="item flex ju-be"
                v-for="(item) in indexData.index_category_list"
                :key="item.id"
              >
                <div class="hd">
                  <a href="javascripy:;" @click="linkgoodslist(item.id)">{{item.name}}</a>
                </div>
                <span class="iconfont icon-right"></span>
                <div class="sonclassfy">
                  <div class="flex ai-sa ju-be">
                    <div style="width:500px;">
                      <div
                        class="sonclassfy_item flex"
                        v-for="(item_i,index_i) in item._child"
                        :key="index_i"
                      >
                        <div class="title_icon flex ">
                          <a
                            class="unlin ellipsis-2"
                            href="javascripy:;"
                            @click="linkgoodslist(item_i.id)"
                          >{{item_i.name}}</a>&nbsp;&nbsp;
                          <span class="icon-right iconfont" style="font-size:12px;"></span>
                        </div>
                        <div class="classfy3">
                          <a
                            class="unlin"
                            href="javascripy:;"
                            @click="linkgoodslist(item_i3.id)"
                            v-for="(item_i3) in item_i._child"
                            :key="item_i3.id"
                          >{{item_i3.name}}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ul class="clearlist nav-main">
            <li v-for="(item,index) in indexData.index_link_top" :key="index">
              <a :href="item.url" target="_blank">{{item.remark}}</a>
             
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="usercenter" v-else>
      <div class="header userheader">
        <div class="container flex">
          <div class="logo">
           <a href="/" target="_blank">
              <img src="/static/images/logo.png" />
            </a>
          </div>
          <div class="usernav" style="margin-top:15px">
            <ul class="clearlist clearfix">
              <li>
                首页
                <i class="iconfont icon-down"></i>
                <div class="downmenu">
                  <ul class="clearlist clearfix">
                    <li>
                      <a href="#/">首页</a>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                账户设置
                <i class="iconfont icon-down"></i>
                <div class="downmenu">
                  <ul class="clearlist clearfix">
                    <li>
                      <a href="#/login">退出登录</a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <!-- <a href="#/cart" class="mallcart">
            <span class="iconfont icon-cart"></span> 我的购物车
            <span v-if="cartnum" class="cart-count">{{cartnum}}</span>
            <span class="cart-count" v-else>{{indexData.index_cartnum}}</span>
          </a> -->
          <div class="search" style="margin-top:0">
            <input type="text" placeholder="搜索商品关键词"  v-model="keyword" />
            <button @click="search" type>
              <i class="iconfont icon-search"></i>
            </button>
          </div>
           <div class="flex">
            <a href="#/cart" class="mallcart">
            <span class="iconfont icon-cart"></span> 我的购物车
            <span v-if="cartnum" class="cart-count">{{cartnum}}</span>
            <span class="cart-count" v-else>{{indexData.index_cartnum}}</span>
          </a>
          <!-- <a href="javascript:;" class="mallcart teletephone">
            <span class="iconfont icon-tel3"></span> {{indexData.index_telephone}}
           
          </a> -->
         </div>
          
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { provinceAndCityData } from "element-china-area-data";

export default {
  name: "Header",
  inject: ["reload"], //注入reload方法
  data() {
    return {
      addrText: "",
      searchGoods: "",
      goodsKeyWord: "",
      keyword: "",
      userpage: false,
      options: provinceAndCityData,
      selectedOptions: [],
      // showSonclassfy: false,
      showobj: {}
    };
  },
  props: {
    indexData: Object,
    userInfo: Object,
    keywords: String,
    cartnum: Number,
    showNav: {
      type: Boolean,
      value: false
    }
  },

  created() {
    this.keyupSubmit();
  },
  methods: {
    keyupSubmit() {
      
      document.onkeydown = e => {
        console.log()
        if(window.location.hash.indexOf('usercenter')!=-1)return;
        let _key = window.event.keyCode;
        if (_key == 13) {
          this.search();
        }
      };
    },
    handleChange(value) {
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].value == value[0]) {
          for (let j = 0; j < this.options[i].children.length; j++) {
            if (this.options[i].children[j].value == value[1]) {
              this.addrText =this.options[i].label + "." + this.options[i].children[j].label;
              document.getElementById("address").innerHTML = this.addrText;
              return;
            }
          }
        }
      }
    },
    myorder() {
      this.$router.push("/usercenter?type=1-1");
      this.reload(); //直接调用
    },
    myfav() {
      this.$router.push("/usercenter?type=2-3");
      this.reload(); //直接调用
    },
    tologin() {
      if (location.hash.indexOf("usercenter")!=-1) {
        this.$router.push("/usercenter");
      }

      this.$router.push("/login");
      // this.reload(); //直接调用
    },
    tousercenter() {
      this.$router.push("/usercenter");
      this.reload(); //直接调用
    },
    // outStyle() {
    //   this.showSonclassfy = false;
    // },
    search() {
      if (!this.keyword || this.keyword == " ") {
        this.$message.error("请输入搜索关键字");
        return;
      }
      if (location.hash.indexOf("goodsList") != -1) {
        this.$emit("my-event", { keyword: this.keyword, categoryid: "" });
      } else {
        this.$router.push({
          path: "/goodsList",
          query: {
            keyword: encodeURI(this.keyword)
          }
        });
      }
    },
    linkgoodslist(categoryid) {
      if (location.hash.indexOf("goodsList") != -1) {
        this.$emit("my-event", { categoryid });
      } else {
        this.$router.push(`goodsList?categoryid=${categoryid}`);
      }
      $(".downmenu").css("display", "none");
    },
    lingUrl(url) {
      if (location.hash.indexOf("goodsList") != -1) {
        if (url.indexOf("categoryid") == -1) {
          location.hash = url;
        } else {
          url = url.substring(url.indexOf("categoryid") + 11, url.length);
          this.$emit("my-event", { categoryid: url });
        }
      } else {
        location.hash = url;
      }
    }
  },

  mounted() {
    this.userpage = this.$route.path.indexOf("usercenter") == -1 ? true : false;
    document.getElementById("address").innerHTML = sessionStorage.city;
    setTimeout(() => {
      $("#districtidswitch").val("四川省" + "成都市" + "" + "/" + "");
      $('[data-toggle="city-picker"]')
        .citypicker("destroy")
        .citypicker();
      layui.use(["form", "layer"], function() {
        var form = layui.form;
        var layer = layui.layer;
      });
    }, 1000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
.container {
  .fl {
    // align-items: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue